const MortgageTypes = {
  FIXED_INTEREST: 'FIXED_INTEREST',
  INTEREST_ONLY: 'INTEREST_ONLY',
  COMBINATION: 'COMBINATION',
  ACCELERATED: 'ACCELERATED',
};

export default MortgageTypes;
